import { Alert, IAlert, AlertCategory } from '.';

export const PatientAlertTypes = [
    'Unable to gain access to patient',
    'Patient not in',
    'Patient requires urgent care',
    'Other',
] as const;

export const PatientAlertResolutions = [
    'Cancelled - alert raised in error',
    'Resolved - Patient care handed to another healthcare professional or service',
    'Resolved - Patient alert dealt with',
    'Resolved - Access to patient gained',
    'Resolved - Whereabouts of patient established',
    'Other',
] as const;

interface IPatientAlert extends IAlert {
    type: typeof PatientAlertTypes[number];
    resolution?: typeof PatientAlertResolutions[number];
    jobId: string;
}

interface PatientAlert extends IPatientAlert {}

class PatientAlert extends Alert {
    category = AlertCategory.PATIENT;

    constructor(data: IPatientAlert) {
        super(data);
        Object.assign(this, data);
    }
}

export { PatientAlert };
